/* eslint-disable @typescript-eslint/no-explicit-any */
// define your typings for the store state
export interface StateAuth {
  accessToken: string | null;
  csrfToken: string;
  count: number;
  customer: any;
  msjErrorNetwork: null;
}

const state = () => ({
  accessToken: null,
  csrfToken: null,
  count: 1,
  customer: null,
  zipCode: null,
  address: [],
  msjErrorNetwork: "" as string,
});

const getLocalStorage = () =>
  typeof localStorage === "object" ? localStorage : undefined;

// mutations
const mutations = {
  setAccessToken(state: StateAuth, newToken: string | null) {
    if (newToken) {
      getLocalStorage()?.setItem("accessToken", newToken);
    } else {
      getLocalStorage()?.removeItem("accessToken");
    }
    state.accessToken = newToken;
  },
  increment(state: StateAuth) {
    state.count++;
  },
  setCsrfToken(state: StateAuth, newToken: string) {
    state.csrfToken = newToken;
  },
  setCustomer(state: StateAuth, newCustomer: string) {
    getLocalStorage()?.setItem("customer", JSON.stringify(newCustomer));
    state.customer = newCustomer;
  },
  setErrorNetwork(state: StateAuth, error: any) {
    state.msjErrorNetwork = error;
  },

  clearErrorNetwork(state: StateAuth) {
    state.msjErrorNetwork = null;
  },
};

const getters = {
  getAccessToken(state: StateAuth) {
    const token = getLocalStorage()?.getItem("accessToken");
    state.accessToken = token || null;
    return state.accessToken;
  },
  getCustomer(state: StateAuth) {
    const customerStr = getLocalStorage()?.getItem("customer");
    const customer = customerStr ? JSON.parse(customerStr) : null;
    state.customer = customer;

    return state.customer;
  },
  getIsUserAuthenticated(state: StateAuth) {
    return state.customer && state.accessToken;
  },
  getErrorNetwork(state: StateAuth) {
    return state.msjErrorNetwork;
  },
};

export const auth = {
  namespaced: true,
  state,
  mutations,
  getters,
};
